import React from 'react'
import clsx from 'clsx'
import { AddCircle, CloseCircle } from 'iconsax-react'
import { useTheme } from '@mui/material'

import UserOption from '@SonarCX/components/atoms/Dropdown/users'
import UserSearchDropdown from '@SonarCX/components/molecules/UserSearchDropdown'

import { isUUID } from '@SonarCX/utilities'
import { useUserAPI } from '@SonarCX/providers/UserAPIProvider'
import useStyles from './styles'

const UserSearch = ({
  userID,
  value,
  setValue,
  hideMe = true,
  withBorder = false,
  switchIcon = false,
  disablePortal = true,
  showTeams = false,
  extraEmbeds = [],
  children = undefined,
  external = false,
  startOpen = false
}) => {
  const theme = useTheme()

  const { getUsers, loadUser } = useUserAPI()
  const classes = useStyles()

  const agents = React.useMemo(() => {
    const allAgents = getUsers(false)
    delete allAgents[userID]
    return Object.values(allAgents)
  }, [getUsers, userID])

  const externalUsers = React.useMemo(() => {
    const allCustomers = getUsers(true)
    return Object.values(allCustomers)
  }, [getUsers])

  const opt = React.useMemo(() => {
    if (external) {
      return externalUsers.find(user => user.id === value)
    }

    return agents.find(agent => agent.id === value)
  }, [external, externalUsers, agents, value])

  // Load selected user if needed
  React.useEffect(() => {
    if (isUUID(value) && !opt) {
      loadUser(value)
    }
  }, [value, opt, loadUser])

  if (isUUID(value)) {
    return (
      <div className={classes.user}>
        <UserOption showTeams={!external} id={value} opt={opt} />

        <CloseCircle
          size={theme.size.base}
          color='grey'
          variant='Bold'
          onClick={() => setValue('null')}
          className='close'
        />
      </div>
    )
  }

  return (
    <UserSearchDropdown
      prevSelected={[]}
      selected={null}
      onSelect={setValue}
      limit={10}
      hideMe={hideMe}
      anchorClass={clsx([classes.anchor, withBorder && classes.border])}
      disablePortal={disablePortal}
      extraEmbeds={extraEmbeds}
      showTeams={showTeams}
      external={external}
      startOpen={startOpen}
    >
      <div className={classes.select}>
        {children ??
          (switchIcon ? (
            <>
              <div>Select user</div>
              <AddCircle size={theme.size.base} className='icon' />
            </>
          ) : (
            <>
              <AddCircle size={theme.size.base} className='icon' />
              <div>Select user</div>
            </>
          ))}
      </div>
    </UserSearchDropdown>
  )
}

export default UserSearch
